import { useSyncExternalStore } from "react";

/**
 * A password sign-in for an account with two-factor on yields no session yet,
 * only a short-lived `mfaToken`. It lives in memory (never persisted) until the
 * authenticator code is entered, which `MfaGate` watches for.
 */
let token: string | null = null;
const listeners = new Set<() => void>();

export const pendingMfa = {
  get: () => token,
  set(next: string | null) {
    token = next;
    for (const listener of listeners) listener();
  },
  subscribe(listener: () => void) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

export function usePendingMfaToken() {
  return useSyncExternalStore(pendingMfa.subscribe, pendingMfa.get, () => null);
}
